<form (submit)="f.form.valid && processDepartment()" #f="ngForm" novalidate >
    <div class="row">
        <!-- DEPARTMENT NAME -->
        <div class="col-md-12">
            <div class="form-group padding-right-10">
                <mat-form-field>
                    <input
                        placeholder="Department Name"
                        matInput
                        [(ngModel)]="department.departmentName"
                        name="name"
                        #name="ngModel"
                        required
                        (keypress)="keyPressAlpha($event)"
                        maxlength="32"
                    >
                    <mat-error *ngIf="name.touched && name.errors?.pattern">Department name is not valid</mat-error>
                </mat-form-field>
            </div>
        </div>
       
    </div>
    <div class="margin-top-20 text-center">
        <button mat-raised-button color="primary" class="mat-button-large" type="submit" [disabled]="!f.valid">
            <span *ngIf="!department?.departmentId">Create Department</span>
            <span *ngIf="department?.departmentId">Update Department</span>
        </button>
    </div>
    </form>